export default function Cross({ size = 12 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.0002 7.24999L2.2501 11.0001C1.90492 11.3453 1.34527 11.3453 1.0001 11.0001C0.654916 10.6549 0.654916 10.0953 1.00009 9.7501L4.7502 5.99999L1.0003 2.2501C0.655123 1.90492 0.655121 1.34527 1.0003 1.0001C1.34548 0.654915 1.90512 0.654917 2.2503 1.0001L6.0002 4.74999L9.7501 1.0001C10.0953 0.654918 10.6549 0.654917 11.0001 1.00009C11.3453 1.34527 11.3453 1.90492 11.0001 2.2501L7.2502 5.99999L11.0003 9.7501C11.3455 10.0953 11.3455 10.6549 11.0003 11.0001C10.6551 11.3453 10.0955 11.3453 9.7503 11.0001L6.0002 7.24999Z" fill="currentColor" />
    </svg>
  )
}

